<template>
  <div id="app" class="whitespace-no-wrap">
    <Leaderboard />
  </div>
</template>

<script>
  import Leaderboard from './components/Leaderboard.vue';

  export default {
    name: 'App',
    components: {
      Leaderboard,
    },
  };
</script>
